import React from 'react';
import { Link } from 'react-router-dom';

// Shared site footer: trademark, copyright, and legal links. Used on the home
// page and the legal pages so the brand and notices read consistently.
function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer style={{ textAlign: 'center', padding: '28px 20px', borderTop: '1px solid var(--border)', color: 'var(--muted)', fontSize: 12, lineHeight: 1.7 }}>
      <div>
        Your Top 8™ is in <span style={{ color: 'var(--accent)', fontWeight: 600 }}>Alpha</span>, so
        expect rough edges. New here? Read the{' '}
        <Link to="/help" style={{ color: 'inherit', textDecoration: 'underline' }}>Help &amp; FAQ</Link>.
        Found a bug or have a thought?{' '}
        <Link to="/feedback" style={{ color: 'inherit', textDecoration: 'underline' }}>Send feedback</Link>.
      </div>
      <div style={{ marginTop: 8 }}>Your Top 8™ is independent, not affiliated with any other social network.</div>
      <div style={{ marginTop: 6 }}>© {year} Your Top 8. All rights reserved.</div>
      <div style={{ marginTop: 10, display: 'flex', justifyContent: 'center', gap: 20, flexWrap: 'wrap' }}>
        <Link to="/help" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Help</Link>
        <Link to="/feedback" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Feedback</Link>
        <Link to="/privacy" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Privacy</Link>
        <Link to="/terms" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Terms</Link>
        <Link to="/legal" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Legal</Link>
        <Link to="/delete-account" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Delete account</Link>
        <a href="mailto:hello@yourtop8.com" style={{ color: 'inherit', textDecoration: 'none', opacity: 0.7 }}>Contact</a>
      </div>
    </footer>
  );
}

export default Footer;
